import { styled } from "styled-components";

export const ContactContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const ContactInteractionContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-left: auto;
`;

export const ContactName = styled.p`
  color: ${(props) => props.theme.colors.default[300]};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
`;

export const ContactTrigger = styled.div`
  color: ${(props) => props.theme.colors.default[600]};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
`;
